// src/redux/feepackageSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_feepackage,
  add_feepackage,
  update_feepackage,
  delete_feepackage,
  get_feepackage_list,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  feepackage: [],
  feepackagelist:[],
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    school_class:"",
    auto_add:false
  },
};

// Async Thunks for API Calls
export const fetchfeepackageList = createAsyncThunk(
    'feepackage/fetchfeepackagelist',
    async ({user_id,class_id,school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_feepackage_list(user_id,class_id,school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  // Async Thunks for API Calls


// Async Thunks for API Calls
export const fetchfeepackage = createAsyncThunk(
  "feepackage/fetchfeepackage",
  async ({ page, page_size,school_id,filter_fields, token, signal }, { rejectWithValue }) => {

    try {
      const response = await get_feepackage(page, page_size,school_id,filter_fields,token, signal);

        
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const createfeepackage = createAsyncThunk(
  "feepackage/createfeepackage",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_feepackage(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatefeepackage = createAsyncThunk(
  "feepackage/updatefeepackage",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_feepackage(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletefeepackage = createAsyncThunk(
  "feepackage/deletefeepackage",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_feepackage({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// feepackage Slice
const feepackageSlice = createSlice({
  name: 'feepackages',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      const { id, name,school_class,auto_add} = action.payload;
      state.formData = { id, name,school_class,auto_add};
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        school_class:"",
        auto_add:false,
      };
    },
    setfeepackage(state, action) {
      state.feepackage = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchfeepackageList.fulfilled, (state, action) => {
        state.feepackagelist = action.payload.data;
      })
      .addCase(fetchfeepackageList.rejected, (state, action) => {
        state.feepackagelist = [];
      })
     
       // Fetch feepackage
       .addCase(fetchfeepackage.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchfeepackage.fulfilled, (state, action) => {
        state.loading = false;
        state.feepackage = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchfeepackage.rejected, (state, action) => {
        state.loading = false;
        state.feepackage = [];
        state.error = action.payload;
      })

      // Add feepackage
      .addCase(createfeepackage.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createfeepackage.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createfeepackage.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update feepackage
      .addCase(updatefeepackage.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatefeepackage.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatefeepackage.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete feepackage
      .addCase(deletefeepackage.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletefeepackage.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletefeepackage.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setfeepackage,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = feepackageSlice.actions;
export default feepackageSlice.reducer;
